import React from "react";

export const msg = (e, d = "Something went wrong.") => e?.response?.data?.detail?.message || d;
export const conflictsOf = (e) => e?.response?.data?.detail?.conflicts || [];
export const iso = (d) => d.toISOString().slice(0, 10);
export const addDays = (s, n) => { const d = new Date(`${s}T12:00:00`); d.setDate(d.getDate() + n); return iso(d); };
export const btn = "min-h-[44px] px-3 rounded border border-erf-borderCream bg-white text-sm hover:bg-erf-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors";
export const primary = "min-h-[44px] px-4 rounded bg-erf-navy text-white text-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50";
export const input = "min-h-[44px] w-full rounded border border-erf-borderCream bg-white px-2 text-sm";

export function Field({ id, label, children }) {
  return (
    <label htmlFor={id} className="flex flex-col gap-1 text-sm">
      <span className="font-medium">{label}</span>
      {children}
    </label>
  );
}

export function Alert({ text, testid }) {
  if (!text) return null;
  return <p role="alert" className="text-sm text-red-800" data-testid={testid}>{text}</p>;
}

export function Card({ children, testid, className = "" }) {
  return <div className={`rounded border border-erf-borderCream bg-white p-3 text-sm ${className}`} data-testid={testid}>{children}</div>;
}

export function ProjectSelect({ projects, value, onChange, testid }) {
  return (
    <select id={testid} className={input} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      <option value="">Choose a project</option>
      {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
    </select>
  );
}
